import { VaccinationpassportComponent } from './webpages/vaccinationpassport/vaccinationpassport.component';
import { VaccinationpassportsComponent } from './ministry/vaccinationpassport/vaccinationpassport.component';
import { AirportpersonnelsComponent } from './ministry/airportpersonnels/airportpersonnels.component';
import { MinistryofhealthusersComponent } from './ministry/ministryofhealthusers/ministryofhealthusers.component';
import { MedicallabsComponent } from './ministry/medicallabs/medicallabs.component';
import { ForgedresultsComponent } from './ministry/forgedresults/forgedresults.component';
import { AirportforgedresultsComponent } from './airport/airportforgedresults/airportforgedresults.component';
import { DefaultersComponent } from './ministry/defaulters/defaulters.component';
import { TotalresultsComponent } from './ministry/totalresults/totalresults.component';
import { RegisteredpassengersComponent } from './ministry/registeredpassengers/registeredpassengers.component';
import { AirportDashboardComponent } from './dashboard/airport-dashboard/airport-dashboard.component';
import { MinistryDashboardComponent } from './dashboard/ministry-dashboard/ministry-dashboard.component';
import { FaqComponent } from './webpages/faq/faq.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactusComponent } from './webpages/contactus/contactus.component';
import { HomeComponent } from './webpages/home/home.component';
import { AboutusComponent } from './webpages/aboutus/aboutus.component';
import { LoginComponent } from './auth/login/login.component';
import { OutboundregistrationComponent } from './passengerregistration/outboundregistration/outboundregistration.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { ResetpasswordComponent } from './auth/resetpassword/resetpassword.component';
import { ReportComponent } from './admin/report/report.component';
import { TestComponent } from './admin/test/test.component';
import { InboundregistrationComponent } from './passengerregistration/Inboundregistration/Inboundregistration.component';
import { LabusersComponent } from './laboratory/labusers/labusers.component';
import { SamplecollectioncentersComponent } from './laboratory/samplecollectioncenters/samplecollectioncenters.component';
import { LabdashboardComponent } from './dashboard/labdashboard/labdashboard.component';
import { SampleCenterDashboardComponent } from './dashboard/sample-center-dashboard/sample-center-dashboard.component';
import { LocatestoreComponent } from './webpages/locatestore/locatestore.component';
import { SampleCenterAppointmentsComponent } from './samplecollection/sample-center-appointments/sample-center-appointments.component';
import { SampleCenterLoggedSamplesComponent } from './samplecollection/sample-center-logged-samples/sample-center-logged-samples.component';
import { SampleCenterResultsComponent } from './samplecollection/sample-center-results/sample-center-results.component';
import { SampleCenterCalendarComponent } from './samplecollection/sample-center-calendar/sample-center-calendar.component';
import { UseractivitiesComponent } from './laboratory/useractivities/useractivities.component';
import { AdduserComponent } from './laboratory/adduser/adduser.component';
import { EmployeesComponent } from './laboratory/employees/employees.component';
import { SampleCenterResultComponent } from './samplecollection/sample-center-result/sample-center-result.component';
import { LoggedsamplesComponent } from './laboratory/loggedsamples/loggedsamples.component';
import { ResultsComponent } from './laboratory/results/results.component';
import { SampleCenterUsersComponent } from './samplecollection/sample-center-users/sample-center-users.component';
import { SampleCenterUsersActivitiesComponent } from './samplecollection/sample-center-users-activities/sample-center-users-activities.component';
import { SampleCenterAddUserComponent } from './samplecollection/sample-center-add-user/sample-center-add-user.component';
import { SampleCentersComponent } from './samplecollection/sample-centers/sample-centers.component';
import { SampleCenterEmployeesComponent } from './samplecollection/sample-center-employees/sample-center-employees.component';
import { ChangepasswordComponent } from './auth/changepassword/changepassword.component';
import { MyprofileComponent } from './auth/myprofile/myprofile.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { UpdaterecordComponent } from './webpages/updaterecord/updaterecord.component';
import { TrackresultComponent } from './webpages/trackresult/trackresult.component';
import { MakepaymentComponent } from './webpages/makepayment/makepayment.component';
import { VerifyuniqueidComponent } from './airport/verifyuniqueid/verifyuniqueid.component';
import { VerifyqrcodeComponent } from './airport/verifyqrcode/verifyqrcode.component';
import { PaymentstatuspageComponent } from './passengerregistration/paymentstatuspage/paymentstatuspage.component';

const routes: Routes = [
	{ path: '', redirectTo: 'home', pathMatch: 'full' },

	{ path: 'faq', component: FaqComponent },
	{ path: 'contactus', component: ContactusComponent },
	{ path: 'home', component: HomeComponent },
	{ path: 'aboutus', component: AboutusComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'outboundregistration', component: OutboundregistrationComponent },
	{ path: 'inboundregistration', component: InboundregistrationComponent },
	{ path: 'forgot', component: ForgotComponent },
	{ path: 'collectioncenters', component: SamplecollectioncentersComponent },
	{ path: 'labusers', component: LabusersComponent },
	{ path: 'adduser', component: AdduserComponent },
	{ path: 'employees', component: EmployeesComponent },
	{ path: 'useractivities', component: UseractivitiesComponent },
	{ path: 'loggedsamples', component: LoggedsamplesComponent },
	{ path: 'results', component: ResultsComponent },
	{ path: 'uniqueid', component: VerifyuniqueidComponent },
	{ path: 'qrcode', component: VerifyqrcodeComponent },

	{ path: 'changepassword', component: ChangepasswordComponent },
	{ path: 'resetpassword', component: ResetpasswordComponent },
	{ path: 'myprofile', component: MyprofileComponent },
	{ path: 'report', component: ReportComponent },
	{ path: 'test', component: TestComponent },
	{ path: 'lab-dashboard', component: LabdashboardComponent },
	{ path: 'logout', component: LogoutComponent },
	{ path: 'updaterecord', component: UpdaterecordComponent },
	{ path: 'trackresult', component: TrackresultComponent },
	{ path: 'paymentstatuspage', component: PaymentstatuspageComponent },

	{ path: 'ministry-dashboard', component: MinistryDashboardComponent },
	{ path: 'registeredpassengers', component: RegisteredpassengersComponent },
	{ path: 'totalresults', component: TotalresultsComponent },
	{ path: 'defaulters', component: DefaultersComponent },
	{ path: 'forgedresults', component: ForgedresultsComponent },
	{ path: 'medicallabs', component: MedicallabsComponent },
	{ path: 'ministryofhealthusers', component: MinistryofhealthusersComponent },
	{ path: 'airportpersonnels', component: AirportpersonnelsComponent },
	{ path: 'vpassport-list', component: VaccinationpassportsComponent },
	//{ path: "airlines", component: AirlinesComponent },
	{ path: 'airportforgedresults', component: AirportforgedresultsComponent },

	{ path: 'ministry-dashboard', component: MinistryDashboardComponent },
	{ path: 'makepayment', component: MakepaymentComponent },
	{ path: 'airport-dashboard', component: AirportDashboardComponent },

	// Sample collection center routes
	{
		path: 'sample-center-dashboard',
		component: SampleCenterDashboardComponent,
	},
	{
		path: 'sample-centers',
		component: SampleCentersComponent,
	},
	{
		path: 'sample-center-appointments',
		component: SampleCenterAppointmentsComponent,
	},
	{
		path: 'sample-center-logged-samples',
		component: SampleCenterLoggedSamplesComponent,
	},
	{
		path: 'sample-center-results',
		component: SampleCenterResultsComponent,
	},
	{
		path: 'sample-center-result',
		component: SampleCenterResultComponent,
	},
	{
		path: 'sample-center-calendar',
		component: SampleCenterCalendarComponent,
	},

	{
		path: 'sample-center-users',
		component: SampleCenterUsersComponent,
	},
	{
		path: 'sample-center-users-activities',
		component: SampleCenterUsersActivitiesComponent,
	},
	{
		path: 'sample-center-add-user',
		component: SampleCenterAddUserComponent,
	},

	{
		path: 'sample-center-employees',
		component: SampleCenterEmployeesComponent,
	},

	{ path: 'locate-store', component: LocatestoreComponent },
	{ path: 'vpassport', component: VaccinationpassportComponent },

	{ path: '**', component: PagenotfoundComponent },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
